import type { NewsArticle } from '../../../types/news';
import {
  CardImage,
  CardBody,
  CardMeta,
  CardDate,
  CardSource,
  CardTitle,
  CardSummary,
  CardFooter,
  CardReadMore,
  CardLink,
} from './styles';

interface NewsCardProps {
  article: NewsArticle;
  onClick?: () => void;
}

export function NewsCard({ article }: NewsCardProps) {
  const href = article.url ?? (article.eventSlug ? `/eventos/${article.eventSlug}` : '#');
  const isExternal = !!article.url;

  return (
    <CardLink
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      initial="idle"
      whileHover="hover"
      transition={{ duration: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <CardImage
        $src={article.image}
        variants={{
          idle: { scale: 1 },
          hover: { scale: 1.04 },
        }}
        transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
      />

      <CardBody>
        <CardMeta>
          <CardDate>{article.dateLabel}</CardDate>
          {article.source && (
            <>
              <span style={{ color: 'var(--border)', fontSize: '0.625rem' }}>•</span>
              <CardSource>{article.source}</CardSource>
            </>
          )}
        </CardMeta>

        <CardTitle
          variants={{
            idle: { y: 0 },
            hover: { y: -2 },
          }}
          transition={{ duration: 0.25 }}
        >
          {article.title}
        </CardTitle>

        <CardSummary>{article.summary}</CardSummary>

        <CardFooter>
          <CardReadMore
            variants={{
              idle: { x: 0 },
              hover: { x: 3 },
            }}
            transition={{ duration: 0.25 }}
          >
            Leia mais →
          </CardReadMore>
        </CardFooter>
      </CardBody>
    </CardLink>
  );
}
